<template>
    <div class="favourite">
        <div class="favourite__front" @click="open = !open">
            <svg class="favourite__svg">
                <use xlink:href="#svg-like"></use>
            </svg>
            <span class="favourite__counter">
            <span v-if="collectFavouriteItems.count > 0">{{ collectFavouriteItems.count }}</span>
        </span>
        </div>
        <transition name="fade">
            <div v-if="open" class="favourite__block">
                <div class="favourite__header">
                    <div class="favourite__title">
                        <h5 v-if="collectFavouriteItems.groupName">{{ collectFavouriteItems.groupName }}</h5>
<!--                        <h5>{{ message.showLike }}</h5>-->
                    </div>
                    <svg class="favourite__close" @click="open = false">
                        <use xlink:href="#svg-close"></use>
                    </svg>
                </div>

                <PerfectScrollbar class="favourite__items">
                    <div v-for="( item, i ) in collectFavouriteItems.items" class="favourite__item">
                        <div class="favourite__image">
                            <img :src="item.picture.src" :alt="item.picture.alt">
                        </div>

                        <div class="favourite__description">
                            <a :href="item.detailPage" class="favourite__name">{{ item.name }}</a>
                            <div class="favourite__prices">
                                <div class="def-price">{{ item.price.printPrice }}</div>
                                <div class="def-price-old">
                                    {{ item.price.printPriceOld }}
                                </div>
                            </div>
                        </div>

                        <svg @click="deleteFromFavorite(item.offer.id || item.id)">
                            <use xlink:href="#svg-close"></use>
                        </svg>
                    </div>
                </PerfectScrollbar>

                <div class="favourite__bottom">
                    <a class="def-button" :href="favourite.routes.listPage.path">{{ countLikes(favourite.message.title) }} </a>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex';

    export default {
        name: 'favourite',
        selector: '.favourite',
        globalName: 'favourite',
        props: {
            result: {
                type: Object,
                default: () => ({
                    "items": [
                        {
                        "id": "51828",
                        "name": "Серьги из белого золота с бриллиантами . Артикул: 210515420201",
                        "detailPage": "/catalog/test/sergi-iz-belogo-zolota-s-brilliantami-artikul-210515420201.html",
                        "article": "51828",
                        "price": {"price": 71287, "printPrice": "71287 грн."},
                        "offer": {"id": "55856", "price": {"price": 71287, "printPrice": "71287 грн."}, "current": true},
                        "offers": [{"id": "55856", "price": {"price": 71287, "printPrice": "71287 грн."}, "current": true}],
                        "propsForCheck": [],
                        "picture": {
                            "alt": "Серьги из белого золота с бриллиантами . Артикул: 210515420201",
                            "src": "/upload/resize_cache/iblock/090/200_200_140cd750bba9870f18aada2478b24840a/0904cb6066c64405952fc6f5be81b6eb.jpg"
                        },
                        "displayProperties": []
                    }
                    ],
                    "routs": {
                        "add": {
                            "method": "post",
                            "path": "/ajax/",
                            "params-example-data": {"id": 123, "action": "addLike"}
                        },
                        "remove": {
                            "method": "post",
                            "path": "/ajax/",
                            "params-example-data": {"id": 123, "action": "removeLike"}
                        }
                    },
                    "messages": {"title": "Обрано (1)"},
                    "pageLikes": {"title": "Обрано (#count#)", "url": "/likes/"}
                })
            }
        },
        data() {
            return {
                obData: this.result,
                open: false
            }
        },
        computed: {
            ...mapState({
                favourite: ({favourite}) => favourite?.data,
                message: ({favourite}) => favourite?.data?.message,

            }),
            id() {
                try {
                    return this.favourite?.offer?.id || this.favourite?.id;
                } catch (err) {
                    console.error(err);
                }
            },
            //отбираем все выбранные товары для отображения в малой "ОБРАНЕ"
            collectFavouriteItems() {
                const group = this.favourite.group;
                if (group.length > 0) {
                    return group.find( main => main.base === 'Y');
                } else {
                    return false;
                }
            }

        },
        methods: {
            deleteFromFavorite(id) {
                const data = {id: id, groupId: this.collectFavouriteItems.id}
                this.$store.dispatch('favourite/deleteFromFavorite', data);
            },
            handlerAnotherClick({target}) {
                if (!target.closest('.favourite')) {
                    this.open = false;
                }
            },
            countLikes(str) {
                let items = this.favourite.items;
                let total = 0;
                if (Array.isArray(items) && items.length > 0) {
                    total = items.length;
                }
                return str.replace('#count#', total);
            },
        },
        watch: {
            open(prevValue) {
                if (prevValue) {
                    document.addEventListener('click', this.handlerAnotherClick);
                } else {
                    document.removeEventListener('click', this.handlerAnotherClick);
                }
            }
        },
        created() {
            this.$store.commit("favourite/setState", this.obData);
        },
      mounted() {

      }


    }
</script>

<style lang="scss" scoped>
    .favourite {
        margin-right: 2px;
        position: relative;
        @include point-md {
            margin-right: 24px;
        }

        &__front {
            display: flex;
            align-items: center;

            &:hover {
                cursor: pointer;
            }
        }

        &__svg {
            width: 20px;
            height: 20px;
            margin-right: 4px;
            @include point-md{
                width: 24px;
                height: 24px;
            }
        }

        &__counter {
            font-weight: 500;
            font-size: rem(14);
            width: 12px;
            transform: translateY(1px);
        }

        &__block {
            background-color: #fff;
            position: absolute;
            top: 100%;
            right: -45px;
            z-index: 3;
            width: 300px;
            @include point-sm{
                right: 0;
            }
            @include point-md{
                width: 350px;
            }
            @include point-lg{
                width: 464px;
            }
        }

        &__header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 48px;
            padding: 0 8px;
            box-shadow: 0px 4px 5px rgba(47, 76, 120, 0.1);
            @include point-md{
                height: 68px;
                padding: 0 24px;
            }
        }

        &__title {
            font-weight: 500;
            font-size: rem(18);
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: var(--text-colour-primary);
        }

        &__close {
            width: 15px;
            height: 15px;
            @include point-md{
                width: 20px;
                height: 20px;
            }
            &:hover {
                cursor: pointer;
            }
        }

        &__items {
            background-color: #F7F8F9;
            padding: 8px 8px 0;
            max-height: 550px;
            overflow-y: auto;
            @include point-md{
                padding: 16px 24px;
            }
        }

        &__item {
            display: flex;
            align-items: center;
            background-color: #fff;
            padding: 0 8px;
            @include point-md{
                padding: 0 16px;
            }
            &:not(:last-child) {
                margin-bottom: 4px;
            }

            svg {
                width: 13px;
                height: 13px;
                flex-shrink: 0;

                &:hover {
                    cursor: pointer;
                }
            }
        }

        &__image {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 76px;
            height: 76px;
            overflow: hidden;
            flex-shrink: 0;
            @include point-md{
                width: 80px;
                height: 80px;
            }
            @include point-lg{
                width: 120px;
                height: 120px;
            }

            img {
                display: block;
                max-width: 100%;
            }
        }

        &__description {
            display: flex;
            flex-direction: column;
            padding: 8px;
            @include point-md{
                padding: 16px;
            }
        }

        &__name {
            font-weight: 500;
            font-size: rem(12);
            line-height: 115%;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: var(--text-colour-primary);
            margin-bottom: 4px;
            @include point-md{
                font-size: rem(14);
                margin-bottom: 16px;
            }
            @include point-lg{
                font-size: rem(16);
            }
        }

        &__bottom {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 16px 0;
            box-shadow: 0px -4px 5px rgba(47, 76, 120, 0.1);
            position: relative;
            @include point-md{
                padding: 24px 0;
            }
        }

        &__prices {
            display: flex;
            align-items: center;
        }

        .def-price {
            font-size: rem(16);
            line-height: 110%;
            color: var(--hyperlink-colour-secondary);
            margin-right: 5px;
            @include point-lg{
                font-size: rem(18);
            }
        }

        .def-price-old {
            color: #757575;
            font-size: rem(14);
            @include point-lg{
                font-size: rem(16);
            }
        }

        .def-button{
            height: 40px;
            @include point-md{
                height: 48px;
            }
        }
    }
</style>